import React from "react";

const RoundedTriangle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
    >
      <path
        d="M7.39014 16.9144C8.53941 18.9419 11.4606 18.9419 12.6099 16.9144L19.5852 4.60908C20.7188 2.60917 19.2742 0.129665 16.9753 0.129665H3.02467C0.725798 0.129665 -0.718844 2.60917 0.414809 4.60907L7.39014 16.9144Z"
        fill="white"
      />
    </svg>
  );
};

export default RoundedTriangle;
